import { useState } from "react";
import SVG from "react-inlinesvg";
import { SudoMenuButton, MenuPopoverItem } from "src/sudokit/components/SudoMenuButton";

interface TrashedItemMenuProps {
  handleRestore: () => Promise<void>;
  disabled?: boolean;
}

export const TrashedItemMenu = ({ handleRestore, disabled }: TrashedItemMenuProps) => {
  const [restoring, setRestoring] = useState(false);

  return (
    <SudoMenuButton
      trigger={
        <button
          className="item-menu"
          aria-label="Item actions"
          disabled={disabled}
          onClick={(e) => e.stopPropagation()}
          onPointerDown={(e) => e.stopPropagation()}
          style={{ border: "none", background: "none", width: 24, height: 24, padding: 0, borderRadius: 5, cursor: "pointer", display: "inline-flex", alignItems: "center", justifyContent: "center" }}
        >
          <SVG src="/assets/hotdog-menu.svg" width={18} height={18} />
        </button>
      }
      side="bottom"
      align="end"
      sideOffset={4}
      collisionPadding={8}
      menuAriaLabel="Item actions"
    >
      <MenuPopoverItem
        className="whitespace-nowrap"
        disabled={restoring}
        onSelect={async () => {
          setRestoring(true);
          await handleRestore();
          setRestoring(false);
        }}
      >
        <span aria-hidden="true">
          <SVG src="/assets/restore.svg" className="[&_path]:!fill-none" />
        </span>
        <span>{restoring ? "Restoring" : "Restore"}</span>
      </MenuPopoverItem>
    </SudoMenuButton>
  );
};
